import { withAuthenticator } from "@aws-amplify/ui-react";
import { useEffect } from "react";
import "./App.css";
import Advance from "./components/Advance/Advance";
import AdvanceLoadProject from "./components/AdvanceLoadProject/AdvanceLoadProject";
import AdvanceProject from "./components/AdvanceProjects/AdvanceProjects2";
import BasicProject from "./components/BasicProjects/BasicProjects2";
import EDA from "./components/EDA/EDA";
import ConfigurableChatbot from "./components/generative AI/ConfigurableChatbot";
import Diversity from "./components/generative AI/Diversity";
import FinanceSummarization from "./components/generative AI/FinanceSummarization";
import OnBoarding from "./components/generative AI/OnBoarding";
import PromptChatbot from "./components/generative AI/PromptChatbot";
import PromptEngineeringFinancial from "./components/generative AI/PromptEngineeringFinancial";
import ServiceManual from "./components/generative AI/ServiceManual";
import TeamMeeting from "./components/generative AI/TeamMetting";
import MainLanding from "./components/MainLanding/MainLandingnew";
import MultiConfigNew from "./components/MultiConfigNew/MultiConfigNew";
import MultiConfigProject from "./components/MultiConfigProject/MultiConfigProject";
import MultiConfigProjectView from "./components/MultiConfigProjectView/MultiConfigProjectView2";
import EmptyBasicProject from "./components/NewBasic/NewBasic2";
import LoadBasicProject from "./components/NewBasicProject/NewBasicProject";
import TestingForm from "./components/TesttingForm/TestingForm";
import { getEduvanceAiUsers } from "./graphql/queries";

import { API } from "aws-amplify";

import "@aws-amplify/ui-react/styles.css";
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import { ThemeProvider } from "@material-ui/core/styles";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import AuditCoach from "./components/generative AI/AuditCoach";
import Bussiness from "./components/generative AI/Bussiness";
import BussinessSim from "./components/generative AI/BussinessSim";
import Chatbot from "./components/generative AI/Chatbot";
import ConflictResolution from "./components/generative AI/ConflictResolution";
import CourseRecommendation from "./components/generative AI/CourseRecommendation";
import CriticalConversation from "./components/generative AI/CriticalConversation";
import CriticalConversationCot from "./components/generative AI/CriticalConversationCot";
import CrucialChatbot from "./components/generative AI/CrucialChatbot";
import CrucialWhisper from "./components/generative AI/CrucialWhisper";
import DataAnalytics from "./components/generative AI/DataAnalytics";
import DataAnalyticsAgentic from "./components/generative AI/DataAnalyticsAgentic";
import Departments from "./components/generative AI/Departments";
import EdgeLiveSolution from "./components/generative AI/EdgeLiveSolution";
import EdgeTool from "./components/generative AI/EdgeTool";
import ExpList from "./components/generative AI/ExpList";
import FaqGenerator from "./components/generative AI/FaqGenerator";
import FeedbackCoach from "./components/generative AI/FeedbackCoach";
import FeedbackSummarization from "./components/generative AI/FeedbackSummarization";
import FinanceComparison from "./components/generative AI/FinanceComparison";
import HindwareBath from "./components/generative AI/HindwareBath";
import HindwareDealer from "./components/generative AI/HindwareDealer";
import HrExpList from "./components/generative AI/HrExpList";
import Ibold from "./components/generative AI/Ibold";
import ImageGen from "./components/generative AI/ImageGen";
import InvoicePoMatching from "./components/generative AI/InvoicePoMatching";
import Iot from "./components/generative AI/Iot";
import IotFineTune from "./components/generative AI/IotFineTune";
import JdResumeAnalysis from "./components/generative AI/JdResumeAnalysis";
import JdResumeChatbot from "./components/generative AI/JdResumeChatbot";
import JdResumeComparison from "./components/generative AI/JdResumeComparison";
import JdResumeDummy from "./components/generative AI/JdResumeDummy";
import LoanColection from "./components/generative AI/LoanCollection";
import LoanSellSummarization from "./components/generative AI/LoanSellSummarization";
import MahindraLoan from "./components/generative AI/MahindraLoan";
import MarketingComparison from "./components/generative AI/MarketingComparison";
import MarketingExplist from "./components/generative AI/MarketingExplist";
import MSARiskAnalysis from "./components/generative AI/MSARiskAnalysis";
import PerformanceFeedback from "./components/generative AI/PerformanceFeedback";
import PharmaItOt from "./components/generative AI/PharmaItOt";
import PolicyChatbot from "./components/generative AI/PolicyChatbot";
import ProcurementRisk from "./components/generative AI/ProcurementRisk";
import ProductDescription from "./components/generative AI/ProductDescription";
import PromptEmailCot from "./components/generative AI/PromptEmailCot";
import PromptEngDepartment from "./components/generative AI/PromptEngDepartment";
import PromptEngineering from "./components/generative AI/PromptEngineering";
import PromptEngJd from "./components/generative AI/PromptEngJd";
import PromptEngMarketing from "./components/generative AI/PromptEngMarketing";
import PromptEngMeetingAgendas from "./components/generative AI/PromptEngMettingAgendas";
import PromptJobCot from "./components/generative AI/PromptJobCot";
import SalesChatbot from "./components/generative AI/SalesChatbot";
import SalesChatSimulator from "./components/generative AI/SalesChatSimulator";
import SalesInteraction from "./components/generative AI/SalesInteraction";
import SalesNegotitation from "./components/generative AI/SalesNegotiation";
import SalesTraining from "./components/generative AI/SalesTraining";
import ScenarioChatbot from "./components/generative AI/ScenrioChatbot";
import SentimentAnalysis from "./components/generative AI/SentimentAnalysis";
import SkillFeedback from "./components/generative AI/SkillFeedback";
import SoftwareSales from "./components/generative AI/SoftwareSales";
import SpeechToText from "./components/generative AI/SpeechToText";
import SupplierQuoteComparison from "./components/generative AI/SupplierQuoteComparison";
import SupplyChain from "./components/generative AI/SupplyChain";
import TilesSaleChat from "./components/generative AI/TilesSalesChat";
import TimeManagement from "./components/generative AI/TimeManagement";
import Vendor from "./components/generative AI/Vendor";
const signUpAttributes = ["email"];

function App() {
  useEffect(() => {
    fetchValidity();
    document.getElementById("bgimage").style.display = "none";
  }, []);

  async function fetchValidity() {
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    var jsondata = JSON.parse(userdata);
    var emailid = `${username}//${
      jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2]["Value"]
    }`;

    const apiData = await API.graphql({
      query: getEduvanceAiUsers,
      variables: { User: emailid },
    });
    // console.log("data from app " + JSON.stringify(apiData.data.getEduvanceAiUsers['expiry']));
    if (!apiData.data.getEduvanceAiUsers) {
      localStorage.setItem("validity", "free");

      localStorage.setItem("accountType", "Free");
    } else {
      if (new Date(apiData.data.getEduvanceAiUsers["expiry"]) > Date.now()) {
        // console.log("yeah baby");
        localStorage.setItem(
          "validity",
          apiData.data.getEduvanceAiUsers["expiry"],
        );
        // setIsPremium(true);
        localStorage.setItem("accountType", "Premium");
      } else {
        localStorage.setItem("validity", "free");
        localStorage.setItem("accountType", "Free");
      }
    }
  }
  return (
    <ThemeProvider>
      <Router>
        <Switch>
          <Route exact path="/">
            <MainLanding />
          </Route>
          <Route path="/finance">
            <ExpList />
          </Route>
          <Route path="/gen-ai-hr-section">
            <HrExpList />
          </Route>
          <Route path="/gen-ai-marketing-section">
            <MarketingExplist />
          </Route>
          <Route path="/bussinesss-manufacturing">
            <Bussiness />
          </Route>
          <Route path="/supply-chain">
            <SupplyChain />
          </Route>
          <Route path="/feedback-coach">
            <FeedbackCoach />
          </Route>
          <Route path="/audit-coach">
            <AuditCoach />
          </Route>
          <Route path="/sales-training">
            <SalesTraining />
          </Route>
          <Route path="/diversity">
            <Diversity />
          </Route>
          <Route path="/prompt-eng-department">
            <PromptEngDepartment />
          </Route>
          <Route path="/supplier-quote-comparison">
            <SupplierQuoteComparison
              title={"Supplier Quote Comparison"}
              link={"./audit-coach"}
            />
          </Route>
          <Route path="/onboarding">
            <OnBoarding title={"Onboarding Discussion"} link={"./diversity"} />
          </Route>
          <Route path="/team-meeting">
            <TeamMeeting title={"Team Meeting"} link={"./diversity"} />
          </Route>
          <Route path="/img-gen">
            <ImageGen title={"Finance Image Generator"} link={"./finance"} />
          </Route>
          <Route path="/marketing-image-generator">
            <ImageGen
              title={"Image Generator"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>
          <Route path="/sales-negotiation">
            <SalesNegotitation
              title={"Sales Negotiation"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>
          <Route path="/iot-tune-fine">
            <IotFineTune
              title={"IoT Fine Tuned Sales"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/sales-chat-simulator">
            <SalesChatSimulator
              title={"IoT Sales Chat Simulator"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/tiles-sales-chat-simulator">
            <TilesSaleChat
              title={"Tiles Sales Chat Simulator"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/crucial-chatbot">
            <CrucialChatbot
              title={"Crucial Conversation Training"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/crucial-whisper">
            <CrucialWhisper
              title={"Crucial Chatbot with Voice"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/ibold">
            <Ibold
              title={"IBOLD Conversation Framework Training"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/sales-chatbot">
            <SalesChatbot
              title={"Whiteoak Sales Chatbot"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/iot">
            {/* <Ibold title={"IoT"} link={"./iot"} /> */}
            <Iot title={"IoT"} link={"./feedback-coach"} />
          </Route>
          <Route path="/sales-interaction">
            <SalesInteraction
              title={"Sales Interaction for Edge Live"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/edge-live-solution">
            <EdgeLiveSolution
              title={"Edge Live Sales Solution"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/hindware-bath-sales">
            <HindwareBath
              title={"Hindware Bathware Sales Chatbot"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/hindware-dealer">
            <HindwareDealer
              title={"New Dealer Sales Chatbot"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/prompt-chatbot">
            <PromptChatbot
              title={"Drafting & Refining Emails"}
              link={"./prompt-eng-department"}
            />
          </Route>
          <Route path="/prompt-email-cot">
            <PromptEmailCot
              title={"Drafting & Refining Emails"}
              link={"./prompt-eng-department"}
            />
          </Route>
          <Route path="/conflict-resolution">
            <ConflictResolution
              title={"Conflict Resolution"}
              link={"./prompt-eng-department"}
            />
          </Route>
          <Route path="/time-management">
            <TimeManagement
              title={"Time management and prioritization"}
              link={"./prompt-eng-department"}
            />
          </Route>
          <Route path="/prompt-job-cot">
            <PromptJobCot
              title={"Feedback Note Generation"}
              link={"./prompt-eng-department"}
            />
          </Route>
          <Route path="/prompt-meeting-agendas">
            <PromptEngMeetingAgendas
              title={"Meeting Agenda Generation"}
              link={"./prompt-eng-department"}
            />
          </Route>
          <Route path="/prompt-eng-jd">
            <PromptEngJd
              title={"Writing job descriptions"}
              link={"./prompt-eng-department"}
            />
          </Route>
          <Route path="/business-sim">
            <BussinessSim />
          </Route>
          <Route path="/scenario-based-chatbot">
            <ScenarioChatbot
              title={"Scenario Base Chatbot"}
              link={"./configurable-chatbot"}
            />
          </Route>
          <Route path="/mahindra-loan">
            <MahindraLoan
              title={"Mahindra Loan Sales Chatbot"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/software-sales">
            <SoftwareSales
              title={"Software Sales Chatbot"}
              link={"./sales-training"}
            />
          </Route>
          <Route path="/prod-desc">
            <ProductDescription
              title={"Product Description Generator"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>
          <Route path="/finance-prod-desc">
            <ProductDescription
              title={"Product Description Generator"}
              link={"./finance"}
            />
          </Route>
          <Route path="/data-analytics">
            <DataAnalytics
              title={"Data Analytics Tool"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/bussiness-data-analytics">
            <DataAnalytics
              title={"Data Analytics"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/data-analytics-new">
            <DataAnalyticsAgentic
              title={"Data Analytics Agentic"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/manufacturing-prompt-engineering">
            <PromptEngineering
              title={"Prompt Engineering using Manufacturing Document"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/manufacturing-doc-comparison">
            <MarketingComparison
              title={"Manufacturing Document Comparison"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/hr-data-analytics-new">
            <DataAnalyticsAgentic
              title={"Data Analytics Agentic"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/finance-data-analytics">
            <DataAnalytics title={"Data Analytics Tool"} link={"./finance"} />
          </Route>
          <Route path="/finance-data-analytics-new">
            <DataAnalyticsAgentic
              title={"Data Analytics Agentic"}
              link={"./finance"}
            />
          </Route>
          <Route path="/audit-data-analytics">
            <DataAnalytics
              title={"Data Analytics Tool"}
              link={"./audit-coach"}
            />
          </Route>
          <Route path="/edge-tool">
            <EdgeTool
              title={"Edge Live Effort Estimation Tool"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/prompt-engineering">
            <PromptEngineering
              title={"Prompt Engineering using HR Document"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/prompt-engineering-policy">
            <PromptEngineering
              title={"Prompt Engineering using Policy Document"}
              link={"./audit-coach"}
            />
          </Route>
          <Route path="/prompt-eng-marketing">
            <PromptEngMarketing
              title={"Prompt Engineering using Marketing"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>
          <Route path="/prompt-engineering-financial">
            <PromptEngineeringFinancial
              title={"Prompt Engineering using Financial Document"}
              link={"./finance"}
            />
          </Route>
          <Route path="/finance-doc-summarization">
            <FinanceSummarization
              title={"Finance Document Summarization"}
              link={"./finance"}
            />
          </Route>
          <Route path="/performance-feedback">
            <PerformanceFeedback
              title={"Performance Feedback"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/critical-conversation">
            <CriticalConversation
              title={"Critical Conversation Simulation"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/critical-conversation-cot">
            <CriticalConversationCot
              title={"Critical Conversation Simulation Cot"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/skill-feedback">
            <SkillFeedback
              title={"Skill Specific Feedback"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/finance-prompt-engineering">
            <PromptEngineering
              title={"Financial Document Chatbot using Prompt Engineering"}
              link={"./finance"}
            />
          </Route>
          <Route path="/vendor">
            <Vendor title={"Vendor Evaluation"} link={"./supply-chain"} />
          </Route>
          <Route path="/marketing-prompt-engineering">
            <PromptEngineering
              title={"Marketing Brochure Chatbot using Prompt Engineering"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>
          <Route path="/interview-summarization">
            <SpeechToText
              title={"Interview Summarization"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/loan-sell-summarization">
            <LoanSellSummarization
              title={"Loan Selling Call Summarization"}
              link={"./finance"}
            />
          </Route>
          <Route path="/loan-call-collection">
            <LoanColection
              title={"Loan Collection Call Summarization"}
              link={"./finance"}
            />
          </Route>
          <Route path="/feedback-summarization">
            <FeedbackSummarization
              title={"Feedback Summarization"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/finance-speech-to-text">
            <SpeechToText title={"Speech to Text"} link={"./finance"} />
          </Route>
          <Route path="/finance-comparison">
            <FinanceComparison
              title={"Finance Report Comparison"}
              link={"./finance"}
            />
          </Route>
          <Route path="/procurement-risk-analysis">
            <ProcurementRisk
              title={"Procurement Risk Analysis"}
              link={"./audit-coach"}
            />
          </Route>
          <Route path="/msa-risk-analysis">
            <MSARiskAnalysis
              title={"MSA Risk Analysis"}
              link={"./audit-coach"}
            />
          </Route>
          <Route path="/policy-document">
            <PolicyChatbot
              title={"Policy Documenet Chatbot"}
              link={"./audit-coach"}
            />
          </Route>
          <Route path="/marketing-comparison">
            <MarketingComparison
              title={"Marketing Brochure Comparison"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>

          <Route path="/jd-resume-analysis">
            <JdResumeAnalysis
              title={"JD to Resume Analysis"}
              link={"./gen-ai-hr-section"}
            />
          </Route>

          <Route path="/jd-resume-dummy">
            <JdResumeDummy
              title={"JD to Resume Analysis"}
              link={"./gen-ai-hr-section"}
            />
          </Route>

          {/* <Route path="/resume-comparison">
            <ResumeComparison
              title={"Job Description to Resume Comparison"}
              link={"./gen-ai-hr-section"}
            />
          </Route> */}
          <Route path="/resume-comparison">
            <JdResumeComparison
              title={"Job Description to Resume Comparison 2"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/jd-resume-assistant">
            <JdResumeChatbot
              title={"Job Role Assistant"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/invoice-po">
            <InvoicePoMatching
              title={"Invoice to PO Matching"}
              link={"./finance"}
            />
          </Route>
          <Route path="/audit-invoice-po">
            <InvoicePoMatching
              title={"Invoice to PO Matching"}
              link={"./audit-coach"}
            />
          </Route>
          <Route path="/course-recommendation">
            <CourseRecommendation
              title={"Course Recommendation"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/service-manual">
            <ServiceManual
              title={"Service Manual Chatbot"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/departments">
            <Departments />
          </Route>
          <Route path="/sentiment-analysis">
            <SentimentAnalysis
              title={"Sentiment Analysis"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/configurable-chatbot">
            <ConfigurableChatbot
              title={"Configurable Chatbot"}
              link={"./feedback-coach"}
            />
          </Route>
          <Route path="/it-ot">
            <PharmaItOt
              title={"IT-OT Gap Analysis"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/chatbot">
            <Chatbot
              chatbotTitle={"Financial Document Chatbot"}
              link={"./finance"}
            />
          </Route>
          <Route path="/marketing-chatbot">
            <Chatbot
              chatbotTitle={"Product Brochure Chatbot"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>
          <Route path="/faq-generator">
            <FaqGenerator
              chatbotTitle={"FAQ Generator"}
              link={"./gen-ai-marketing-section"}
            />
          </Route>
          <Route path="/service-chatbot">
            <Chatbot
              chatbotTitle={"Equipment Service Chatbot"}
              link={"./bussinesss-manufacturing"}
            />
          </Route>
          <Route path="/resume-question-chatbot">
            <Chatbot
              chatbotTitle={"Interview Questions Generation Chatbot"}
              link={"./gen-ai-hr-section"}
            />
          </Route>
          <Route path="/finance-audit">
            <Chatbot
              chatbotTitle={"Financial Audit Questions Generation"}
              link={"./finance"}
            />
          </Route>
          <Route path="/basic">
            <BasicProject /> {/*list of projects */}
          </Route>
          <Route path="/basicnew">
            <EmptyBasicProject />
            {/*new empty project*/}
          </Route>
          <Route path="/basicproject/:uname/:pname">
            <LoadBasicProject />
            {/*load project json*/}
          </Route>
          <Route path="/intermediate">
            <MultiConfigProjectView />
          </Route>
          <Route path="/intermediatenew">
            <MultiConfigNew />
          </Route>
          <Route path="/intermediateproject/:uname/:pname">
            <MultiConfigProject />
          </Route>
          <Route path="/advance">
            <AdvanceProject />
          </Route>
          <Route path="/advancenew">
            <Advance />
          </Route>
          <Route path="/advanceproject/:uname/:pname">
            <AdvanceLoadProject />
          </Route>
          <Route path="/test/:uname/:pname">
            <TestingForm />
          </Route>
          <Route path="/eda/:uname/:pname">
            <EDA />
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  );
}

// export default withAuthenticator(App,{signUpConfig});
export default withAuthenticator(App, { signUpAttributes });
